// Yellow Theme Configuration
const guiColors = {
    // Motion (Yellow version)
    'motion-primary': '#FFD700', // Gold / Bright Yellow
    'motion-primary-transparent': '#FFD700E6',
    'motion-tertiary': '#CCAB00', // Darker Yellow for borders/depth

    // Looks (Yellow version)
    'looks-secondary': '#FFD700',
    'looks-transparent': '#FFD70059',
    'looks-light-transparent': '#FFD70026',
    'looks-secondary-dark': 'hsla(45, 100%, 35%, 1)', // Golden Brown shade

    // Extensions (Yellow version)
    'extensions-primary': 'hsla(48, 100%, 50%, 1)',
    'extensions-tertiary': 'hsla(48, 100%, 30%, 1)',
    'extensions-transparent': 'hsla(48, 100%, 50%, 0.35)',
    'extensions-light': 'hsla(48, 100%, 85%, 1)',

    // Drop Highlight
    'drop-highlight': '#FFF176' // Pale Yellow
};

const blockColors = {
    checkboxActiveBackground: '#FFD700',
    checkboxActiveBorder: '#CCAB00'
};

export {
    guiColors,
    blockColors
};
